/*
 *  This file os-dropdowns.service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022  
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { Injectable } from '@angular/core';
import { HttpService } from '../http-service';
import * as _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { HroneGlobalStateService } from 'src/app/store/global/global-state.service';
import { TKeyValue } from '../../models/common.models';

export enum osDdUrls {
    company = '/api/core/Company',
    businessUnit = '/api/core/BusinessUnit',
    department = '/api/core/Department',
    subDepartment = '/api/core/SubDepartment',
    designation = '/api/core/Designation',
    grade = '/api/core/Grade',
    level = '/api/core/Level',
    businessUnitCompanyWise = '/api/core/BusinessUnit/BindDropDown',
    subDepDepartmentWise = '/api/core/SubDepartment/BindDropDown',

    departmentMapped = '/api/core/Department/Mapped/', // ?businessUnitCode=
    designationMapped = '/api/core/Designation/Mapped/', // ?businessUnitCode=
    gradeMapped = '/api/core/Grade/Mapped/', // ?businessUnitCode=
    levelMapped = '/api/core/Level/Mapped/' // ?businessUnitCode=
}

@Injectable({
    providedIn: 'root'
})
export class OsDropdownsService {

    companyDd: any[] = [];
    businessUnitDd: any[] = [];
    businessUnitCompanyWiseDd: any[] = [];
    departmentDd: any[] = [];
    subDepartmentDd: any[] = [];
    subDepartmentDepartmentWiseDd: any[] = [];
    designationDd: any[] = [];
    gradeDd: any[] = [];
    levelDd: any[] = [];
    enterpriseDetail: any;

    companyActiveDd:TKeyValue<string>[] = [];
    businessUnitActiveDd:TKeyValue<string>[]= [];
    businessUnitCompanyWiseActiveDd: any[] = [];
    departmentActiveDd:TKeyValue<string>[] = [];
    subDepartmentActiveDd: TKeyValue<string>[] = [];
    subDepartmentDepartmentWiseActiveDd: any[] = [];
    designationActiveDd:TKeyValue<string>[] = [];
    gradeActiveDd:TKeyValue<string>[] = [];
    levelActiveDd:TKeyValue<string>[] = [];

    departmentMappedActiveDd: any[] = [];
    designationMappedActiveDd: any[] = [];
    gradeMappedActiveDd: any[] = [];
    levelMappedActiveDd: any[] = [];
    constructor(
        private readonly _httpService: HttpService,private readonly _globalStateService: HroneGlobalStateService

    ) { }

    resetCompanyDropDown() {
        this.companyDd = [];
        this.getCompanyDropDown();
    }

    getCompanyDropDown() {
        const bs = new BehaviorSubject<TKeyValue<string>[]>([])

        if (this.companyDd.length) {
            bs.next(this.companyActiveDd)
            return bs.asObservable();
        }

        this._globalStateService.getCompanies().subscribe((response) => {
            const list = _.sortBy(response, [e => e.companyName.toLowerCase()]);
            this.companyDd = list.map(mapper => ({ value: mapper.companyName, key: mapper.companyCode }));

            const filteredList = list.filter(data => data.activeStatus === '1');
            this.companyActiveDd = filteredList.map(mapper => ({ value: mapper.companyName, key: mapper.companyCode }));
            bs.next(this.companyActiveDd);
        });
        return bs.asObservable();
    }

    getCompanyDropDownAsPromise(): Promise<TKeyValue<string>[]> {
        return new Promise((resolve) => {
            if (this.companyDd.length) {
                resolve([...this.companyActiveDd]);
                return;
            }
            this._globalStateService.getCompanies().subscribe((response) => {
                const list = _.sortBy(response, [e => e.companyName.toLowerCase()]);
                this.companyDd = list.map(mapper => ({ value: mapper.companyName, key: mapper.companyCode }));
                const filteredList = list.filter(data => data.activeStatus === '1');
                this.companyActiveDd = filteredList.map(mapper => ({ value: mapper.companyName, key: mapper.companyCode }));
                resolve([...this.companyActiveDd]);
            });
        });
    }

    resetBusinessUnitDropDown() {
        this.businessUnitDd = [];
        this.getBusinessUnitDropDown();
    }

    getBusinessUnitDropDown(): Promise<TKeyValue<string>[]> {
        return new Promise((resolve) => {
            if (this.businessUnitDd.length) {
                resolve([...this.businessUnitActiveDd]);
                return;
            }
            this._globalStateService.getBusinessUnits().subscribe((response) => {
                const list = _.sortBy(response, [e => e.businessUnitName.toLowerCase()]);
                this.businessUnitDd = list.map(mapper => ({ value: mapper.businessUnitName, key: mapper.businessUnitCode }));
                const filteredList = list.filter(data => data.activeStatus === '1');
                this.businessUnitActiveDd = filteredList.map(mapper => ({ value: mapper.businessUnitName, key: mapper.businessUnitCode }));
                resolve([...this.businessUnitActiveDd]);
            });
        });
    }

    getBusinessUnitCompanyWiseDropDown(companyCode: string | number | undefined) {
        this.businessUnitCompanyWiseDd = [];
        this.businessUnitCompanyWiseActiveDd = [];

        const dataModel = {
            businessUnitCode: '0',
            companyCode: companyCode,
            status: '0,1',
            pagination: {
                pageNumber: 0,
                pageSize: 0
            }
        };
        return new Promise((resolve) => {
            this._httpService.Post(osDdUrls.businessUnitCompanyWise, dataModel).subscribe((response) => {

                const list = _.sortBy(response, [e => e.businessUnitName.toLowerCase()]);
                this.businessUnitCompanyWiseDd = list.map(mapper => ({ value: mapper.businessUnitName, key: mapper.businessUnitCode }));

                const filteredList = list.filter(data => data.activeStatus === '1');
                this.businessUnitCompanyWiseActiveDd =
                    filteredList.map(mapper => ({ value: mapper.businessUnitName, key: mapper.businessUnitCode }));
                resolve(this.businessUnitCompanyWiseActiveDd);
            });

        })
    }

    resetDepartmentDropDown() {
        this.departmentDd = [];
        this.getDepartmentDropDown();
    }

    getDepartmentDropDown(): Promise<TKeyValue<string>[]> {
        return new Promise((resolve) => {
            if (this.departmentDd.length) {
                resolve([...this.departmentActiveDd]);
                return;
            }
            this._globalStateService.getDepartments().subscribe((response) => {
                const list = _.sortBy(response, [e => e.departmentName.toLowerCase()]);
                this.departmentDd = list.map(mapper => ({ value: mapper.departmentName, key: mapper.departmentCode }));
                const filteredList = list.filter(data => data.activeStatus === '1');
                this.departmentActiveDd = filteredList.map(mapper => ({ value: mapper.departmentName, key: mapper.departmentCode }));
                resolve([...this.departmentActiveDd]);
            });
        });
    }

    getEnterpriseDetail() {
        this._globalStateService.getEnterprise().subscribe((response) => {
            this.enterpriseDetail = response[0];
        });
    }

    resetSubDepartmentDropDown() {
        this.subDepartmentDd = [];
        this.getSubDepartmentDropDown();
    }

    getSubDepartmentDropDown(): Promise<TKeyValue<string>[]> {
        return new Promise((resolve) => {
        if (this.subDepartmentDd.length) {
            resolve([...this.subDepartmentActiveDd]);
            return;
        }

        this._globalStateService.getSubDepartments().subscribe((response) => {
            const list = _.sortBy(response, [e => e.subDepartmentName.toLowerCase()]);
            this.subDepartmentDd = list.map(mapper => ({ value: mapper.subDepartmentName, key: mapper.subDepartmentCode }));

            const filteredList = list.filter(data => data.activeStatus === '1');
            this.subDepartmentActiveDd = filteredList.map(mapper => ({ value: mapper.subDepartmentName, key: mapper.subDepartmentCode }));
            resolve([...this.subDepartmentActiveDd]);
        });
        });
    }

    resetDesignationDropDown() {
        this.designationDd = [];
        this.getDesignationDropDown();
    }

    getDesignationDropDown(): Promise<TKeyValue<string>[]> {
        return new Promise((resolve) => {
        if (this.designationDd.length) {
            resolve([...this.designationActiveDd]);
            return;
        }

        this._globalStateService.getDesignations().subscribe((response) => {
            const list = _.sortBy(response, [e => e.designationName.toLowerCase()]);
            this.designationDd = list.map(mapper => ({ value: mapper.designationName, key: mapper.designationCode }));

            const filteredList = list.filter(data => data.activeStatus === '1');
            this.designationActiveDd = filteredList.map(mapper => ({ value: mapper.designationName, key: mapper.designationCode }));
            resolve([...this.designationActiveDd]);
        });
        });
    }

    resetGradeDropDown() {
        this.gradeDd = [];
        this.getGradeDropDown();
    }

    getGradeDropDown(): Promise<TKeyValue<string>[]> {
        return new Promise((resolve) => {

        if (this.gradeDd.length) {
            resolve([...this.gradeActiveDd]);
            return;
        }

        this._globalStateService.getGrades().subscribe((response) => {
            const list = _.sortBy(response, [e => e.gradeName.toLowerCase()]);
            this.gradeDd = list.map(mapper => ({ value: mapper.gradeName, key: mapper.gradeCode }));

            const filteredList = list.filter(data => data.activeStatus === '1');
            this.gradeActiveDd = filteredList.map(mapper => ({ value: mapper.gradeName, key: mapper.gradeCode }));
        });
        });
    }

    resetLevelDropDown() {
        this.levelDd = [];
        this.getLevelDropDown();
    }

    getLevelDropDown(): Promise<TKeyValue<string>[]> {
        return new Promise((resolve) => {

        if (this.levelDd.length) {
            resolve([...this.levelActiveDd]);
            return;
        }

        this._globalStateService.getLevels().subscribe((response) => {
            const list = _.sortBy(response, [e => e.levelName.toLowerCase()]);
            this.levelDd = list.map(mapper => ({ value: mapper.levelName, key: mapper.levelCode }));

            const filteredList = list.filter(data => data.activeStatus === '1');
            this.levelActiveDd = filteredList.map(mapper => ({ value: mapper.levelName, key: mapper.levelCode }));
            resolve([...this.levelActiveDd]);
        });
        });
    }


    getSubDepartmentDropDownDepartmentWise(departmentCode: string | number) {
        this.subDepartmentDepartmentWiseDd = [];
        const url = osDdUrls.subDepDepartmentWise;
        const request = {
            subDepartmentCode: '',
            departmentCode: String(departmentCode),
            status: '0,1',
            pagination: {
                pageNumber: 0,
                pageSize: 0
            }
        };

        return new Promise((resolve) => {
            this._httpService.Post(url, request).subscribe((response) => {
                const list = _.sortBy(response, [e => e.subDepartmentName.toLowerCase()]);
                this.subDepartmentDepartmentWiseDd = list.map(mapper => ({ 
                    value: mapper.subDepartmentName, 
                    key: mapper.subDepartmentCode 
                }));

                const filteredList = list.filter(data => data.activeStatus === '1');
                this.subDepartmentDepartmentWiseActiveDd = filteredList.map(mapper =>
                    ({ value: mapper.subDepartmentName, key: mapper.subDepartmentCode }));
                resolve(this.subDepartmentDepartmentWiseActiveDd);
            });
        });
    }

    getDepartmentMappedDropDown(buCode: string | number | undefined) {
        this.departmentMappedActiveDd = [];
        return new Promise((resolve) => {
            this._httpService.Get(osDdUrls.departmentMapped + buCode).subscribe((response) => {
                const list = _.sortBy(response, [e => e.departmentName.toLowerCase()]);
                const filteredList = list.filter(data => data.activeStatus === '1');
                this.departmentMappedActiveDd = filteredList.map(mapper => ({ 
                    value: mapper.departmentName, 
                    key: mapper.departmentCode 
                }));
                resolve(this.departmentMappedActiveDd);
            });
        });
    }

    getDesignationMappedDropDown(buCode: string | number | undefined, callback?: () => void, skillId?: string | number, departmentId?: string | number) {
        let isStatutorySkillsMandatory = false
        this._globalStateService.getWorkforceSetupSetting(106).subscribe((res) => {
            if (res?.status === 'Y') {
                isStatutorySkillsMandatory = true;
            }
            this.designationMappedActiveDd = [];
            const url = isStatutorySkillsMandatory ? osDdUrls.designationMapped + buCode + `/${skillId ? skillId : 0}${departmentId ? `/${departmentId}` : ''}` : osDdUrls.designationMapped + buCode + `/0`;
            this._httpService.Get(url).subscribe((response) => {

                const list = _.sortBy(response, [e => e.designationName.toLowerCase()]);

                const filteredList = list.filter(data => data.activeStatus === '1');
                this.designationMappedActiveDd = filteredList.map(mapper => ({ value: mapper.designationName, key: mapper.designationCode, gradeId: mapper.gradeId }));
                if (callback) callback();
            });
        });

    }

    getGradeMappedDropDown(buCode: string | number | undefined) {
        this.gradeMappedActiveDd = [];
        return new Promise((resolve) => {
            this._httpService.Get(osDdUrls.gradeMapped + buCode).subscribe((response) => {
                const list = _.sortBy(response, [e => e.gradeName.toLowerCase()]);
                const filteredList = list.filter(data => data.activeStatus === '1');
                this.gradeMappedActiveDd = filteredList.map(mapper => ({ 
                    value: mapper.gradeName, 
                    key: mapper.gradeCode 
                }));
                resolve(this.gradeMappedActiveDd);
            });
        });
    }

    getLevelMappedDropDown(buCode: string | number | undefined) {
        this.levelMappedActiveDd = [];
        return new Promise((resolve) => {
            this._httpService.Get(osDdUrls.levelMapped + buCode).subscribe((response) => {
                const list = _.sortBy(response, [e => e.levelName.toLowerCase()]);
                const filteredList = list.filter(data => data.activeStatus === '1');
                this.levelMappedActiveDd = filteredList.map(mapper => ({ 
                    value: mapper.levelName, 
                    key: mapper.levelCode 
                }));
                resolve(this.levelMappedActiveDd);
            });
        });
    }
    // end mapped dropdowns

    reset() {
        this.companyDd = [];
        this.businessUnitDd = [];
        this.businessUnitCompanyWiseDd = [];
        this.departmentDd = [];
        this.subDepartmentDd = [];
        this.subDepartmentDepartmentWiseDd = [];
        this.designationDd = [];
        this.gradeDd = [];
        this.levelDd = [];
        this.enterpriseDetail = null;
        this.companyActiveDd = [];
        this.businessUnitActiveDd = [];
        this.businessUnitCompanyWiseActiveDd = [];
        this.departmentActiveDd = [];
        this.subDepartmentActiveDd = [];
        this.subDepartmentDepartmentWiseActiveDd = [];
        this.designationActiveDd = [];
        this.gradeActiveDd = [];
        this.levelActiveDd = [];
        this.departmentMappedActiveDd = [];
        this.designationMappedActiveDd = [];
        this.gradeMappedActiveDd = [];
        this.levelMappedActiveDd = [];
    }

    allDropDown() {
        this.getCompanyDropDown();
        this.getBusinessUnitDropDown();
        this.getDepartmentDropDown();
        this.getSubDepartmentDropDown();
        this.getDesignationDropDown();
        this.getGradeDropDown();
        this.getLevelDropDown();
    }






}

const empSearchSkeleton = {
    enterpriseCode: '',
    companyCode: '',
    businessUnitCode: '',
    departmentCode: '',
    subDepartmentCode: '',
    gradeCode: '',
    designationCode: '',
    levelCode: '',
    branchCode: '',
    subBranchCode: '',
    regionCode: '',
    employeeCode: '',
    employeeId: 0,
    employeeName: '',
    employeeStatus: '',
    employeeType: ''
};

